var map = {
	"./archer/compound bow.png": 3797,
	"./archer/diamond bow.png": 9665,
	"./archer/eagle helmet.png": 9846,
	"./archer/frozen bow.png": 2402,
	"./archer/golden armor.png": 6769,
	"./archer/golden bow.png": 2070,
	"./archer/golden helmet.png": 6433,
	"./archer/hunter armor.png": 6529,
	"./archer/hunter bow.png": 6050,
	"./archer/hunter helmet.png": 9308,
	"./archer/infernal bow.png": 3897,
	"./archer/infernal breastplate.png": 7592,
	"./archer/infernal hat.png": 8954,
	"./archer/leather armor.png": 386,
	"./archer/leather helmet.png": 9984,
	"./archer/leviathan armor.png": 2977,
	"./archer/lord armor.png": 4106,
	"./archer/musketeer armor.png": 8529,
	"./archer/musketeer bow.png": 750,
	"./archer/musketeer hat.png": 2270,
	"./archer/silver armor.png": 4838,
	"./archer/simple bow.png": 6047,
	"./archer/tiger helmet.png": 380,
	"./archer/wolf helmet.png": 9055,
	"./mage/avernal robe.png": 4249,
	"./mage/fire hat.png": 9109,
	"./mage/fire robe.png": 2479,
	"./mage/frozen crown.png": 8789,
	"./mage/frozen robe.png": 4699,
	"./mage/frozen staff.png": 5645,
	"./mage/gnarled stick.png": 7631,
	"./mage/infernal crown.png": 4865,
	"./mage/infernal robe.png": 4484,
	"./mage/infernal staff.png": 1824,
	"./mage/legendary robe.png": 532,
	"./mage/legendary staff.png": 5365,
	"./mage/magic hat.png": 4623,
	"./mage/palatine tunic.png": 6138,
	"./mage/royal robe.png": 4179,
	"./mage/shadow crown.png": 6631,
	"./mage/shadow oculus.png": 1721,
	"./mage/shadow robe.png": 2737,
	"./mage/shadow staff.png": 5745,
	"./mage/skull collector.png": 3427,
	"./mage/socketed staff.png": 7877,
	"./mage/trainee hat.png": 18,
	"./mage/wizzard hat.png": 9642,
	"./mage/xor hat.png": 1714,
	"./none/agregar/agregar-6.png": 9321,
	"./none/angel wings.png": 2426,
	"./none/boat.png": 2631,
	"./none/boots of steel.png": 3187,
	"./none/common gloves.png": 9855,
	"./none/demon wings.png": 2125,
	"./none/gloves of steel.png": 502,
	"./none/grand royal crown.png": 8242,
	"./none/pants of steel.png": 8247,
	"./none/pirate boat.png": 219,
	"./none/pirate galleon.png": 7571,
	"./none/pirate galley.png": 1346,
	"./none/potion.png": 9093,
	"./none/progress gem.png": 3938,
	"./none/royal crown.png": 8306,
	"./none/royal galleon.png": 4826,
	"./none/royal galley.png": 145,
	"./warrior/armor of the swamp.png": 5459,
	"./warrior/fire armor.png": 3833,
	"./warrior/fire helmet.png": 8981,
	"./warrior/fire shield.png": 689,
	"./warrior/fire sword.png": 7791,
	"./warrior/flame sword.png": 2896,
	"./warrior/frozen armor.png": 7823,
	"./warrior/frozen helmet.png": 9016,
	"./warrior/frozen shield.png": 1190,
	"./warrior/frozen sword.png": 2621,
	"./warrior/full iron helmet.png": 5957,
	"./warrior/gala plate armor.png": 9019,
	"./warrior/golden sword.png": 4149,
	"./warrior/helmet of steel.png": 4339,
	"./warrior/imperial shield.png": 4654,
	"./warrior/infernal armor.png": 3199,
	"./warrior/infernal helmet.png": 1418,
	"./warrior/infernal shield.png": 9578,
	"./warrior/infernal sword.png": 7895,
	"./warrior/kinght armor.png": 6294,
	"./warrior/legendary armor.png": 3702,
	"./warrior/legionary shield.png": 9340,
	"./warrior/lizard armor.png": 6442,
	"./warrior/lizard helmet.png": 7424,
	"./warrior/lizard shield.png": 649,
	"./warrior/lizard sword.png": 6083,
	"./warrior/sapphire sword.png": 2422,
	"./warrior/silver clad helm.png": 4375,
	"./warrior/silver helmet.png": 3735,
	"./warrior/silver shield.png": 6709,
	"./warrior/silver sword.png": 2924,
	"./warrior/sparkling shield.png": 1842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9988;